import { useContent } from "../../../context/ContentContext";
import { Editable } from "../../../context/design";

export default function AboutSection() {
  const { about } = useContent();

  return (
    <section id="about" className="relative py-20 md:py-32 w-full bg-sky-50">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="max-w-4xl mx-auto text-center mb-16 md:mb-24">
          <Editable as="p" id="about.label" label="Kleine Beschriftung" className="text-sm text-sky-600 font-medium tracking-widest uppercase mb-4">{about.label}</Editable>
          <Editable as="h2" id="about.title" label="Überschrift" className="text-3xl sm:text-4xl md:text-5xl font-bold text-sky-950 leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            {about.title_line1}<br />
            <span className="italic font-normal text-sky-700">{about.title_italic}</span><br />
            {about.title_line3}
          </Editable>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          <div className="relative bg-gradient-to-br from-sky-100 to-rose-50 rounded-3xl p-8 md:p-10">
            <div className="absolute top-6 right-6">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-sky-800"></i>
              </div>
            </div>
            <span className="text-5xl md:text-6xl font-bold text-sky-900/20" style={{ fontFamily: "'Playfair Display', serif" }}>01</span>
            <div className="mt-6">
              <Editable as="h3" id="about.card1_title" label="Karte 1 – Überschrift" className="text-xl md:text-2xl font-bold text-sky-900 mb-4">{about.card1_title}</Editable>
              <Editable as="p" id="about.card1_text" label="Karte 1 – Text" className="text-sky-800/80 leading-relaxed">{about.card1_text}</Editable>
            </div>
            <Editable as="p" id="about.card1_quote" label="Karte 1 – Zitat" className="mt-6 text-sky-700 italic text-sm">{about.card1_quote}</Editable>
          </div>

          <div className="relative bg-gradient-to-br from-sky-100 to-indigo-50 rounded-3xl p-8 md:p-10">
            <div className="absolute top-6 right-6">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-sky-800"></i>
              </div>
            </div>
            <span className="text-5xl md:text-6xl font-bold text-sky-900/20" style={{ fontFamily: "'Playfair Display', serif" }}>02</span>
            <div className="mt-6">
              <Editable as="h3" id="about.card2_title" label="Karte 2 – Überschrift" className="text-xl md:text-2xl font-bold text-sky-900 mb-4">{about.card2_title}</Editable>
              <Editable as="p" id="about.card2_text" label="Karte 2 – Text" className="text-sky-800/80 leading-relaxed">{about.card2_text}</Editable>
            </div>
            <Editable as="p" id="about.card2_quote" label="Karte 2 – Zitat" className="mt-6 text-sky-700 italic text-sm">{about.card2_quote}</Editable>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center mt-16 md:mt-24">
          <Editable as="p" id="about.bottom_text" label="Abschlusstext" className="text-lg md:text-xl text-sky-800/80 leading-relaxed">{about.bottom_text}</Editable>
        </div>
      </div>
    </section>
  );
}
